import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export enum VenueId {
    Grow = 'grow',
    Ally = 'ally',
    Connect = 'connect',
    Share = 'share',
}

export interface Venue {
    id: VenueId;
    label: string;
    description: string;
    themeClass: string; // activates venue CSS variables from venues.theme.scss
    icon: IconDefinition;
    hidden?: boolean; // true = out of scope, not shown in UI and not accessible
}
